import axios from "axios";
import { ApiUrl } from "../Constants/Weburl";

const END_POINT = `${ApiUrl}api/auth/`

const adminToken = localStorage.getItem("adminToken");

console.log('adminToken' , adminToken);


export const login = (email, password ) =>{
  console.log("call",`${END_POINT}login`)
  return axios 
  .post(`${END_POINT}login`, {email , password , isAdminLogin: true })
  .then((response) => {
    return response;
  }).catch(e=>{
    console.log("response" , e)
    return e?.response;
  })    
};


//acceptreport api 
export const acceptReport = async (reportId) => {
  const token = localStorage.getItem("adminToken");
  return axios.patch(
    `${ApiUrl}api/reports/${reportId}/accept`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};





//rejectreport api 
export const rejectReport = async(reportId) => {
    const token = localStorage.getItem("adminToken");
    return axios.patch(
        `${ApiUrl}api/reports/${reportId}/reject`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    } 
    );
}


//hashtag api

//global search api 
// export const fetchGlobalSearchResults = (query, cancelToken) => {
//   return axios.get(`${ApiUrl}api/searchglobal`, {
//     params: { q: query },
//     cancelToken,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}`,
//     },
//   });
// };


export const fetchGlobalSearchResults = (query, cancelToken, category = "") => {
  const params = { q: query };
  if (category) params.category = category;

  return axios.get(`${ApiUrl}api/searchglobal`, { params, cancelToken });
};


export const rejectWithdrawal = async (token, requestId) => {
    try {
        const response = await axios.post(
            `${ApiUrl}api/reject/withdraw`,
            {
                requestId: requestId,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.log(
            "REJECT WITHDRAWAL SERVICE ERROR:",
            error?.response?.data || error.message
        );

        throw error;
    }
};

export const fetchRejectedWithdrawals = async (token) => {
    try {
        const res = await axios.get(
            `${ApiUrl}api/rejectedlist/withdraw`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        console.log("REJECTED WITHDRAWALS:", res.data);

        return res.data;

    } catch (error) {
        console.log(
            "REJECTED WITHDRAWALS SERVICE ERROR:",
            error?.response?.data || error.message
        );

        throw error;
    }
};


export const addCoinPackage = async (adminToken, data) => {
    console.log("token", adminToken);
    try {
        const response = await axios.post(
            `${ApiUrl}api/coinpurchaseamount`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${adminToken}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.log(
            "Add coin package error:",
            error.response?.data || error.message
        );

        throw error;
    }
};


export const getCoinPurchases = async (adminToken) => {
    const response = await axios.get(
        `${ApiUrl}api/getcoinpurchase`,
        {
            headers: {
                Authorization: `Bearer ${adminToken}`,
            },
        }
    );

    return response.data;
};


export const updateCoinPurchase = async (token, id, data) => {
    const response = await axios.put(
        `${ApiUrl}api/updatecoinpurchaseamount/${id}`,
        data,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};

export const deleteCoinPurchase = async (token, id) => {
    const response = await axios.delete(
        `${ApiUrl}api/deletecoinpurchase/${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};


export const getAdminSettings = async (token) => {
  try {
    const response = await axios.get(
      `${ApiUrl}api/getadminsettings`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log(
      "GET ADMIN SETTINGS ERROR:",
      error.response?.data || error.message
    );

    throw error;
  }
};

export const saveAdminSettings = async (token, formData) => {
  try {
    const response = await axios.post(
      `${ApiUrl}api/saveadminsettings`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log(
      "SAVE ADMIN SETTINGS ERROR:",
      error.response?.data || error.message
    );

    throw error;
  }
};


// Userlevel api
export const createUserLevelCoin = async (adminToken, data) => {
    try {
        const response = await axios.post(
            `${ApiUrl}api/postlevelcoin`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${adminToken}`,
                },
            }
        );

        return response.data;

    } catch (error) {
        console.log(
            "CREATE LEVEL COIN ERROR:",
            error.response?.data || error.message
        );

        throw error;
    }
};


//getlevel api
export const getLevelCoins = async (adminToken) => {
    try {
        const response = await axios.get(
            `${ApiUrl}api/getlevelcoin`,
            {
                headers: {
                    Authorization: `Bearer ${adminToken}`,
                },
            }
        );

        return response.data;

    } catch (error) {
        console.log(
            "GET LEVEL COINS ERROR:",
            error.response?.data || error.message
        );

        throw error;
    }
};

//updatelevel api
export const updateUserLevelCoin = async (adminToken, id, data) => {
    try {
        const response = await axios.put(
            `${ApiUrl}api/updatelevelcoin/${id}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${adminToken}`,
                },
            }
        );

        return response.data;

    } catch (error) {
        console.log(
            "UPDATE LEVEL COIN ERROR:",
            error.response?.data || error.message
        );

        throw error;
    }
};

export const deleteLevelCoins = async (adminToken, id) => {
    const response = await axios.delete(
        `${ApiUrl}api/deletelevelcoin/${id}`,
        {
            headers: {
                Authorization: `Bearer ${adminToken}`,
            },
        }
    );

    return response.data;
};


export const getCurrencySettings = async (adminToken) => {
    try {
        const response = await axios.get(
            `${ApiUrl}api/getcurrencysettings`,
            {
                headers: {
                    Authorization: `Bearer ${adminToken}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.log("getCurrencySettings error:", error);
        throw error;
    }
};

export const updateCurrencySettings = async (adminToken, settingsData) => {
    try {
        const response = await axios.put(
            `${ApiUrl}api/updatecurrencysettings`,
            settingsData,
            {
                headers: {
                    Authorization: `Bearer ${adminToken}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    } catch (error) {
        console.log("updateCurrencySettings error:", error);
        throw error;
    }
};


//currency grid api 

//get api
// export const getCurrencies = async (search = '', page = 1, limit = 10 , adminToken) => {
//   const res = await axios.get(`${ApiUrl}api/currencies`, 
//     { 
//                 headers: {
//                     Authorization: `Bearer ${adminToken}`,
//                     "Content-Type": "application/json",
//                 },
//              },
//         {
//     params: { search, page, limit }
//   });
//   return res.data; // { success, data, pagination }
// };

export const getCurrencies = async (
    search = '',
    page = 1,
    limit = 10,
    adminToken
) => {
    const res = await axios.get(
        `${ApiUrl}api/currencies`,
        {
            headers: {
                Authorization: `Bearer ${adminToken}`,
                "Content-Type": "application/json",
            },
            params: {
                search,
                page,
                limit,
            },
        }
    );

    return res.data;
};

// Add new currency
export const addCurrency = async (currencyData , adminToken) => {
  const res = await axios.post(`${ApiUrl}api/currencies`, currencyData , 
        {
            headers: {
                Authorization: `Bearer ${adminToken}`,
                "Content-Type": "application/json",
            },
        }
  );
  return res.data;
};

// Edit currency
export const updateCurrency = async (id, currencyData , adminToken) => {
  const res = await axios.put(`${ApiUrl}api/currencies/${id}`, currencyData , 
        {
            headers: {
                Authorization: `Bearer ${adminToken}`,
                "Content-Type": "application/json",
            },
        }
  );
  return res.data;
};

// Delete currency
export const deleteCurrency = async (id , adminToken) => {
  const res = await axios.delete(`${ApiUrl}api/currencies/${id}` ,
     {
                headers: {
                Authorization: `Bearer ${adminToken}`,
                "Content-Type": "application/json",
            },
        }
  );
  return res.data;
};

// Toggle status
export const toggleCurrencyStatus = async (id , adminToken) => {
  const res = await axios.patch(`${ApiUrl}api/selectcurrencies/${id}/toggle`, {} ,
    {
                headers: {
                Authorization: `Bearer ${adminToken}`,
                "Content-Type": "application/json",
            },
        }
  );
  return res.data;
};


export const togglenabledCurrencyStatus = async (id , adminToken) => {
  const res = await axios.patch(`${ApiUrl}api/enabledcurrencies/${id}/toggle`, {} ,
    {
                headers: {
                Authorization: `Bearer ${adminToken}`,
                "Content-Type": "application/json",
            },
        }
  );
  return res.data;
};


export const getSelectedCurrencies = async (adminToken) => {
  const res = await axios.get(
    `${ApiUrl}api/getselectedcountry`,
    {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    }
  );

  return res.data;
};

export const setBaseCurrency = async (id, adminToken) => {
  const res = await axios.patch(`${ApiUrl}api/currencies/${id}/set-base`, {}, {
    headers: { Authorization: `Bearer ${adminToken}` }
  });
  return res.data;
};

export const getBaseCurrency = async (adminToken) => {
  const res = await axios.get(`${ApiUrl}api/currencies/base`, {
    headers: { Authorization: `Bearer ${adminToken}` }
  });
  return res.data;
};


export const getUserById = async (token, id) => {
    const response = await axios.get(
        `${ApiUrl}api/auth/getadminuser/${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};



//admin edit profile
export const adminUpdateUserProfile = async (token, id, formData) => {
    const response = await axios.put(
        `${ApiUrl}api/auth/users/${id}/profile`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};

export const adminAddCoins = async (token, id, coins) => {
    const response = await axios.post(
        `${ApiUrl}api/auth/adminaddcoins/${id}`,
        { coins },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};

// ---------- DeepAR filters ----------
export const getDeeparFilters = async (adminToken) => {
  const response = await axios.get(`${ApiUrl}api/getdeeparfilters`, {
    headers: { Authorization: `Bearer ${adminToken}` },
  });
  return response.data;
};

export const addDeeparFilter = async (adminToken, formData) => {
  const response = await axios.post(`${ApiUrl}api/postdeeparfilters`, formData, {
    headers: { Authorization: `Bearer ${adminToken}` },
  });
  return response.data;
};

export const deleteDeeparFilter = async (adminToken, id) => {
  const response = await axios.delete(`${ApiUrl}api/deletedeeparfilters/${id}`, {
    headers: { Authorization: `Bearer ${adminToken}` },
  });
  return response.data;
};


//deeparkey
export const getDeeparKey = async (adminToken) => {
  const response = await axios.get(`${ApiUrl}api/getdeeparkey`, {
    headers: { Authorization: `Bearer ${adminToken}` },
  });
  return response.data;
};

export const saveDeeparKey = async (adminToken, data) => {
  const response = await axios.put(`${ApiUrl}api/savedeeparkey`, data, {
    headers: { Authorization: `Bearer ${adminToken}` },
  });
  return response.data;
};


//forgetpassword

export const adminforgetpassword = async (email) => {
  const res = await axios.post(
    `${ApiUrl}api/auth/forgot-password`,
    { email } , {
         headers: { Authorization: `Bearer ${adminToken}` },
    }
  );

  return res.data;
};